<template>
    <page :showDashboardButton="true">
        <h1>Wir verschenken Personality Selfies</h1>
        <div class="ion-text-center">
            <img
                width="500"
                :src="
                    baseurl +
                    '/content/dam/klickmal/Allgemein/personality-test-selfie-icon_echo_2.png'
                "
            />
        </div>
        <ion-button
            expand="block"
            :href="
                baseurl +
                '/pages/bestfit-bestandskunden.html?customerid=' +
                $store.state.user.details.customeridformatted
            "
            class="ion-margin-top"
            target="_blank"
            >Jetzt mitmachen</ion-button
        >
    </page>
</template>

<script>
import Page from "@/components/Page";
import { BASEURL } from "@/utils/globals";

export default {
    components: { Page },
    data() {
        return {
            baseurl: BASEURL,
        };
    },
};
</script>

<style></style>
